module.exports = __webpack_public_path__ + "static/media/refresh.c1471e7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/refresh.svg
// module id = 721
// module chunks = 0